import { Col, Row } from 'react-bootstrap';
import Button from 'v3/components/Button';
import styled from 'styled-components';
import Switch from '@mui/material/Switch';
import Label from 'components/Label';

export const RowStyled = styled(Row)`
  margin-top: 3%;
`;

export const ColStyled = styled(Col)`
  display: flex;
  justify-content: end;
  margin-top: 2%;
`;

export const ButtonCancel = styled(Button)`
  margin-right: 2%;
`;

export const StyledSwitch = styled(Switch)`
  &.Mui-checked {
    color: #ffffff;
  }

  &.Mui-checked + .MuiSwitch-track {
    background-color: #099b94;
  }
`;

export const StyledLabel = styled(Label)`
  && {
    margin-left: 10%;
    color: #27364b;
    font-weight: 600;
  }
`;

export const GridStyled = styled.div`
  padding: 1rem;
`;
